import Parser from 'html-react-parser';
import { useEffect, useRef } from 'react';
import { useAEMResource } from '@hooks';
import { AEM_HEADER_HEIGHT } from '@config/constants';

const Header = () => {
  const ref = useRef<HTMLElement | null>(null);
  const { stylesLoaded, header, onMounted } = useAEMResource();

  useEffect(() => {
    if (ref.current) onMounted();
  }, [header, stylesLoaded, ref.current])

  if (!stylesLoaded || !header) return <div style={{ height: `${AEM_HEADER_HEIGHT}px` }}></div>;

  return <>{Parser(header)}</>;
}

export { Header };
